var SW = require('js/lib/sw');
var $ = require('js/sw-jquery/sw-jquery');
var fragments = require('js/lib/sw-fragments');

function showLogInSignUpTab(tab) {
  $('.login-modal-tabs').find('li').removeClass('active-modal-tab');
  $('.mmc-login-modal-tabs').find('li').removeClass('active-modal-tab');
  $('.' + tab + '-modal-tab').addClass('active-modal-tab');
  $('.modal-form').hide();

  $('.' + tab + '-modal-form').show();

  //this causes the modal to resize and position itself (needed because the two tabs have completely different content height
  $.fancybox.update();

}

function openLogInSignUpDialog(activeTab, getKey, internalReferrer, contextCopy, referrer, options) {
  options = options || {};

  if(contextCopy) {
    $('.contextCopy').html(contextCopy);
  }
  else {
    $('.contextCopy').html('');
  }

  var contentHref = fragments.getHref('loginModal', {
    endpoint: options.contentHref,
    targetUrl: referrer
  });

  if (!contentHref) {
   contentHref = '/fragments/login-modal';
  }

  $.fancybox({
    href        : contentHref,
    type        : 'ajax',
    ajax        : {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    },
    autoSize    : false,
    autoResize  : false,
    fitToView   : false,
    autoCenter  : true,
    leftRatio   : 0,
    padding     : 0,
    width       : 'auto',
    height      : 'auto',
    keys: {
      close: [
        27
      ]
    },
    beforeShow: function() {
      showLogInSignUpTab(activeTab);
    },
    afterShow  : function () {
      SW.trigger('sw-fragment-loaded', $('#fancybox-wrap'));
      $('#sign_up_referrer').val(referrer);
      $('#login_referrer').val(referrer);

      var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      if (w <=1024) {
        $.extend(this, {
          margin: new Array(80,0,0,0),
          autoCenter:false,
          fitToView:false,
          topRatio:0
        });
      }

      $('#fancybox-wrap .' + activeTab + '-modal-form').find('input').filter(':visible:first').focus();

      if (options.doneEvent) {
        $('input[name="targetUrl"]').val('event:' + options.doneEvent);
      }

    }
  });

  var modal = $('#fancybox-wrap');

  var getKeyValue = (getKey && getKey === true);
  $(modal).find('.getKey').val(getKeyValue);

  var userNameInput = $('#sign_up_username');
  var passWordInput = $('#sign_up_password');

  $(userNameInput).live('blur', function() {

    var userName = $(this).val();
    if (userName === '') { return; }
    var usernameError = '';

    if (userName.length < 4) {
      usernameError = 'Minimum 4 characters';
    }
    else if (userName.length > 50 ) {
      usernameError = 'Max 50 characters';
    }
    else if (/[^\w]/.exec(userName)) {
      usernameError = 'Only numbers, letters and underscores allowed';
    }
    else if (/shapeways/.exec(userName)) {
      usernameError = 'No Shapeways allowed!';
    }

    $(this).parents('li').find('.username-error').html(usernameError).show();

  });

  $(userNameInput).live('keyup', function() {
    $(this).parents('li').find('.username-error').hide();
  });


  $(passWordInput).live('blur', function() {
    var password = $(this).val();
    if (password === '') { return; }
    var passwordError = '';

    $(this).parents('li').find('.password-error').html(passwordError).show();

  });

  $(passWordInput).live('keyup', function() {
    $(this).parents('li').find('.password-error').hide();
  });

  return true;
}

function hideLoginSignup() {
  $.fancybox.close();
}

module.exports = {
  hideLoginSignup: hideLoginSignup,
  openLogInSignUpDialog: openLogInSignUpDialog,
  showLogInSignUpTab: showLogInSignUpTab
};
